import React from "react";

const Experiences = () => {
    return (
        <div className="bg-[#add3f7] bg-cover bg-center z-0 w-full flex flex-col h-screen md:pt-44 pt-8 overflow-x-hidden">
            <img alt="" className="md:w-0 md:h-0 w-16 h-16 z-20 rounded-full border-blue-900 border-2 place-self-center" src="\assests\analysed_in_logo.jpeg"></img>
            <div className=" self-center  flex w-fit bg-gray-50 p-5 z-10  mt-[-12px] mx-4 flex-col rounded-md shadow-md">
                <div className=" grid md:grid-flow-col  grid-flow-row md:gap-0 gap-1">
                    <div className="flex md:flex-row self-center flex-col md:gap-4 gap-1">
                        <h1 className="md:text-2xl text-xl font-[acme] text-black ">Mobile Application developer Intern</h1>
                        <a className="font-sans-serif self-start md:text-xl" rel="noreferrer" target="_blank" href="https://in.linkedin.com/company/analysed-in"> @ Analysed.in</a>
                    </div>

                    <img alt="" className="md:w-16 md:h-16 w-0 h-0 mr-4 rounded-full border-blue-900 border-2 place-self-end" src="\assests\analysed_in_logo.jpeg"></img>

                </div>
                <text className="mt-2 text-sm ">Jan-2023 - Apr-2023 (3 Months)</text>
                <h2 className="mt-2 font-semibold font-[Bree Serif] text-black text-sm"><i class='fas fa-map-marker-alt'></i>  Noida, Uttar Pradesh</h2>
                <ul className=" mt-2 items-start self-start ">
                    <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Developed a Fitness Android application using JAVA and XML, showcasing proficiency in mobile app development</li>
                    <li className="text-[14px] text-black text-justify md:text-left mt-1">● Utilized PHP and XMAPP to effectively retrieve and display data from databases, demonstrating strong database
                        management skills.</li>
                    <li className="text-[14px] text-black text-justify md:text-left mt-1">● Successfully implemented third-party libraries to enhance application functionality, resulting in an improved user
                        experience.
                    </li>
                </ul>
                <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">Android SDK</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">Java</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">XML</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">PHP</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">phpMyAdmin</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">Firebase</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">XMAPP</div>
                    <div className="md:px-5 px-3 py-[0.2vh] text-justify text-white font-Courier-New rounded bg-[#003a76]">Android Studio</div>
                </div>
            </div>
        </div>
    )
}

export default Experiences; 
